import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { action } from 'satcheljs/lib/legacy';
/**
 * Callback when load more rows request succeeds
 * @param tableView to load
 * @param newRows to be merged
 * @param newTotalRowsInView the number of new total rows
 * @param appendRowsWithSeekToConditionResponse the action to update rows in list view store
 */
export var onLoadMoreRowsSucceeded = action('onLoadMoreRowsSucceeded')(function onLoadMoreRowsSucceeded(tableView, newRows, newTotalRowsInView, appendRowsWithSeekToConditionResponse) {
    tableView.isLoading = false;
    // Update rows in listview store
    appendRowsWithSeekToConditionResponse(tableView, newRows, newTotalRowsInView);
    // Always update current loaded index to all items loaded since user triggered load more
    tableView.currentLoadedIndex = tableView.rowKeys.length;
});
/**
 * Callback when load more rows request failed
 * @param tableView to load
 * @param responseCode which is contained in the load more response
 */
export var onLoadMoreRowsFailed = action('onLoadMoreRowsFailed')(function onLoadMoreRowsFailed(tableView, responseCode) {
    tableView.isLoading = false;
    // Log error received from server
    logUsage(datapoints.loadMoreRowsFromServerError.datapoint.name, datapoints.loadMoreRowsFromServerError.datapoint.customData(tableView.tableQuery.listViewType, responseCode));
});
//# sourceMappingURL=onLoadMoreRowsCompleted.js.map